import {
  GetIssueRelationshipsResponseDto,
  useApi,
} from '@issuemanager/api-client';
import {
  ExtendedAxiosError,
  useAppConfig,
} from '@issuemanager/apps/client/hooks';
import { useFeatureFlags } from '@issuemanager/client/features/users';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

const MOCK_RELATIONSHIPS: GetIssueRelationshipsResponseDto[] = [
  {
    id: 1,
    createdAt: new Date('2024-01-15'),
    relatedObject: {
      id: '1',
      type: 'evidence',
      service: 'internal-controls',
      name: 'Q4 Financial Audit Evidence',
    },
  },
  {
    id: 2,
    createdAt: new Date('2024-01-20'),
    relatedObject: {
      id: '2',
      type: 'evidence',
      service: 'internal-controls',
      name: 'Compliance Review Documentation',
    },
  },
  {
    id: 3,
    createdAt: new Date('2024-02-01'),
    relatedObject: {
      id: '3',
      type: 'evidence',
      service: 'internal-controls',
      name: 'IT Security Assessment Results',
    },
  },
];

export function useIssueRelationships(
  issueCode?: string,
): UseQueryResult<GetIssueRelationshipsResponseDto[], ExtendedAxiosError> {
  const api = useApi();
  const appConfig = useAppConfig();
  const isIssueRelationshipsEnabled = useFeatureFlags(
    'issueRelationships',
  ) as boolean;

  return useQuery<GetIssueRelationshipsResponseDto[], ExtendedAxiosError>({
    queryKey: ['issue-relationships', issueCode],
    queryFn: async () => {
      if (!issueCode) {
        return [];
      }

      if (appConfig.isLocalDev) {
        return MOCK_RELATIONSHIPS;
      }

      const response = await api.issuesApi.getIssueRelationships(issueCode);
      return response.data || [];
    },
    enabled: !!issueCode && isIssueRelationshipsEnabled,
  });
}
